import { HTMLProps, useCallback, useContext } from "react";
import classnames from "classnames";
import { IRadioContext, RadioContext } from ".";
import { Element } from "../..";

interface IProps extends HTMLProps<HTMLInputElement> {
    value: string | number;
}

const RadioItem = ({ value, onChange, children, ...radioProps }: IProps) => {
    const consumer = useContext<IRadioContext>(RadioContext);
    const handleCheck = useCallback(
        (e: any) => {
            consumer.onChange(value);
            if (onChange) {
                onChange(e);
            }
        },
        [consumer]
    );

    return (
        <Element
            renderAs="label"
            className={classnames(
                "radio",
                "relative",
                "flex items-center",
                'grow',
                "pl-[20px]",
                "text-[13px]",
                "cursor-pointer"
            )}
        >
            <input
                type="radio"
                value={value}
                checked={consumer.value === value}
                className={classnames(
                    "peer/radio",
                    "absolute",
                    "opacity-0",
                    "cursor-pointer",
                )}
                onChange={handleCheck}
                {...radioProps}
            />
            <Element
                className={classnames(
                    "checkmark",
                    "block",
                    "h-[12px] w-[12px]",
                    "bg-white",
                    "rounded-full",
                    "border border-solid border-[var(--primary)]",
                    "absolute left-0 top-[3px]",
                    "before:absolute before:w-[4px] before:h-[4px] before:left-[3px] before:top-[3px]",
                    "before:bg-white before:rounded-[50%]",
                    "peer-checked/radio:bg-[var(--primary)] peer-checked/radio:before:block"
                )}
            ></Element>
            <Element className={"radio-label"}>{children}</Element>
        </Element>
    );
};

export default RadioItem;
